export default __webpack_public_path__ + "static/media/keyboardArrowDown.0da2392d.svg";